module.exports = __webpack_public_path__ + "static/media/avatar.517bb0cb.png";